import React from "react";
import "./CardsInt.css";
import bad from "../img/offers/bad.webp";
import küche from "../img/offers/küche.webp";
import architecture from "../img/offers/architecture.webp";
import laminate from "../img/offers/boden.webp";
import betreuer from "../img/offers/betreuer.webp";
import boden from "../img/offers/laminate.webp";
import { useState, useRef } from "react";
import emailjs from "emailjs-com";




const CardsInt = (props) => {

  const form = useRef();

  const [isFlipped, setIsFlipped] = useState(false);

  const closeFunc2 = (event) => {
    
    setIsFlipped(false);
  }
  const closeFunc = (event) => {
    event.preventDefault();
    setIsFlipped(!isFlipped);
  }

  
const sendEmail = (e) => {
  e.preventDefault();

  emailjs.sendForm('service_cdksce8', 'template_w9ikxmk', form.current  , 'rWipc_p71bWM4AYNt')
    .then((result) => {
        console.log(result.text);
        console.log(form.current);
        setIsFlipped(!isFlipped);
    }, (error) => {
        console.log(error.text);
    });
    e.target.reset()
    alert("Vielen Dank für Ihre Anfrage. Wir werden uns schnellstmöglich bei Ihnen melden.")
    setIsFlipped(!isFlipped);
  };


  return (
    <div>
      {/* Hello world */}
      <section className="offers">
        <div className="container">
          <div className="offers__container">
            <div className="offers__card-container offers__card-container--flip">
              <div className="offers__card">
                <div className="offers__card-primary">
                  <div className="offers__image-container">
                    <img className="offers__image" src={architecture} alt="" />
                  </div>
                  <div className="offers__content">
                    <h4 className="offers__content-heading">{props.lang === "de" ? "Bauprojekte" : "Building projects"}</h4>
                    <p className="offers__content-subheading">
                      {props.lang === "de" ? "Service | Schlüsselfertig | Erfahrung" : "Service | Turnkey | Experience"}
                    </p>
                    {/*<div class="offers__content-info">
      <div class="offers__content-info-duration">
      
      <span class="offers__content-info-duration-text">Service | Schlüsselfertig | Erfahrung<strong></strong></span>
      </div>
      
      </div>*/}
                    <div className="offers__content-price-container">
                      <strong className="offers__content-price">
                        <svg className="icon" viewBox="0 0 256 256">
                          <defs></defs>
                          <g
                            style={{
                              stroke: "none",
                              strokeWidth: 0,
                              strokeDasharray: "none",
                              strokeLinecap: "butt",
                              strokeLinejoin: "miter",
                              strokeMiterlimit: 10,
                              fill: "white",
                              fillRule: "nonzero",
                              opacity: 1,
                            }}
                            transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
                          >
                            <path
                              d="M 69.524 43.298 h -0.449 c -0.99 0 -1.93 0.218 -2.774 0.609 c -0.641 -2.99 -3.304 -5.238 -6.481 -5.238 H 59.37 c -1.135 0 -2.204 0.287 -3.139 0.792 c -1.002 -2.392 -3.367 -4.076 -6.118 -4.076 h -0.448 c -0.934 0 -1.822 0.194 -2.628 0.543 v -9.516 c 0 -3.655 -2.974 -6.628 -6.629 -6.628 h -0.449 c -3.655 0 -6.628 2.974 -6.628 6.628 v 24.376 l -3.022 2.294 c -2.403 1.824 -3.927 4.479 -4.29 7.475 c -0.363 2.994 0.482 5.935 2.379 8.279 l 9.423 11.649 v 4.633 c 0 2.799 2.277 5.076 5.076 5.076 h 23.518 c 2.799 0 5.076 -2.277 5.076 -5.076 l 0.001 -4.398 c 3.01 -3.782 4.659 -8.476 4.659 -13.3 V 49.927 C 76.152 46.271 73.179 43.298 69.524 43.298 z M 72.152 67.421 c 0 4.123 -1.484 8.129 -4.18 11.281 c -0.311 0.362 -0.48 0.823 -0.48 1.3 v 5.117 c 0 0.594 -0.482 1.076 -1.076 1.076 H 42.898 c -0.593 0 -1.076 -0.482 -1.076 -1.076 v -5.341 c 0 -0.458 -0.157 -0.901 -0.445 -1.258 l -9.868 -12.199 c -1.21 -1.496 -1.75 -3.372 -1.518 -5.283 s 1.204 -3.604 2.737 -4.77 l 0.604 -0.458 v 5.539 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 v -9.547 c 0 -0.015 0 -0.029 0 -0.044 V 26.413 c 0 -1.449 1.179 -2.628 2.628 -2.628 h 0.449 c 1.449 0 2.628 1.179 2.628 2.628 v 15.601 c 0 0 0 0 0 0.001 s 0 0 0 0.001 l 0.009 12.976 c 0.001 1.104 0.896 1.999 2 1.999 c 0 0 0.001 0 0.001 0 c 1.105 -0.001 2 -0.896 1.999 -2.001 l -0.01 -12.966 c 0 -0.003 0.001 -0.006 0.001 -0.01 c 0 -1.449 1.179 -2.628 2.628 -2.628 h 0.448 c 1.449 0 2.629 1.179 2.629 2.628 v 3.285 c 0 0 0 0.001 0 0.001 c 0 0 0 0.001 0 0.001 l 0.009 9.692 c 0.001 1.104 0.896 1.998 2 1.998 c 0.001 0 0.001 0 0.002 0 c 1.104 -0.001 1.999 -0.897 1.998 -2.002 l -0.009 -9.69 c 0 -1.449 1.179 -2.628 2.628 -2.628 h 0.449 c 1.449 0 2.628 1.179 2.628 2.628 v 4.107 c -0.006 0.066 -0.02 0.13 -0.02 0.197 l 0.01 5.392 c 0.002 1.104 0.897 1.996 2 1.996 c 0.001 0 0.002 0 0.004 0 c 1.104 -0.002 1.998 -0.899 1.996 -2.004 l -0.009 -4.875 c 0.006 -0.062 0.019 -0.121 0.019 -0.184 c 0 -1.449 1.179 -2.628 2.628 -2.628 h 0.449 c 1.449 0 2.628 1.179 2.628 2.628 V 67.421 z"
                              style={{
                                stroke: "none",
                                strokeWidth: 1,
                                strokeDasharray: "none",
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                fill: "white",
                                fillRule: "nonzero",
                                opacity: 1,
                              }}
                              transform=" matrix(1 0 0 1 0 0) "
                              strokeLinecap="round"
                            />
                            <path
                              d="M 28.5 33.873 c -0.668 0 -1.321 -0.334 -1.7 -0.943 c -1.517 -2.437 -2.319 -5.249 -2.319 -8.131 c 0 -8.495 6.911 -15.406 15.406 -15.406 c 8.495 0 15.406 6.911 15.406 15.406 c 0 1.483 -0.211 2.95 -0.626 4.361 c -0.313 1.061 -1.427 1.668 -2.484 1.354 c -1.06 -0.312 -1.665 -1.424 -1.354 -2.483 c 0.308 -1.044 0.464 -2.131 0.464 -3.231 c 0 -6.29 -5.116 -11.406 -11.406 -11.406 s -11.406 5.117 -11.406 11.406 c 0 2.135 0.593 4.216 1.714 6.017 c 0.584 0.938 0.297 2.171 -0.641 2.755 C 29.226 33.775 28.86 33.873 28.5 33.873 z"
                              style={{
                                stroke: "none",
                                strokeWidth: 1,
                                strokeDasharray: "none",
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                fill: "white",
                                fillRule: "nonzero",
                                opacity: 1,
                              }}
                              transform=" matrix(1 0 0 1 0 0) "
                              strokeLinecap="round"
                            />
                            <path
                              d="M 27.248 45.541 c -0.385 0 -0.774 -0.111 -1.118 -0.343 c -6.791 -4.588 -10.846 -12.214 -10.846 -20.4 c 0 -13.566 11.037 -24.603 24.603 -24.603 S 64.49 11.232 64.49 24.798 c 0 3.103 -0.571 6.13 -1.697 8.996 c -0.404 1.028 -1.563 1.537 -2.593 1.13 c -1.028 -0.404 -1.534 -1.564 -1.13 -2.593 c 0.942 -2.398 1.42 -4.933 1.42 -7.533 c 0 -11.36 -9.242 -20.603 -20.603 -20.603 c -11.36 0 -20.603 9.243 -20.603 20.603 c 0 6.855 3.396 13.242 9.085 17.085 c 0.916 0.618 1.156 1.862 0.538 2.777 C 28.521 45.232 27.89 45.541 27.248 45.541 z"
                              style={{
                                stroke: "none",
                                strokeWidth: 1,
                                strokeDasharray: "none",
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                fill: "white",
                                fillRule: "nonzero",
                                opacity: 1,
                              }}
                              transform=" matrix(1 0 0 1 0 0) "
                              strokeLinecap="round"
                            />
                          </g>
                        </svg>
                      </strong>
                    </div>
                  </div>
                </div>
                <div className="offers__card-hover">
                  <p className="offers__content-subheading-hover">
           {props.lang === "de" ? ( <>Als kompetenter Partner in der Baubranche unterstützen wir
                    Sie beginnend bei der Planung, geben Ihnen Tipps zur
                    Finanzierung und stehen Ihnen bei der finalen Umsetzung mit
                    unserem Baubegleitungs-Service zur Seite.
                    <><br /> <br /></>
                    Sobald Ihr Anwesen Belagsfertig ist, errichten wir die
                    weiteren Arbeiten zum schlüsselfertigen Wohnhaus.
                    <><br /> <br /></>
                    Wir sind für die gesamte Umsetzung Ihr kompetenter Partner
                    mit über 30 Jahren Erfahrung.
                    <><br /> <br /></>
                    Nehmen Sie unverbindlich Kontakt mit uns auf und wir starten
                    gemeinsam mit Ihren Plänen durch.</>):(<>As a competent partner in the construction industry we support you
                    support you from the planning stage onwards, give you tips on
                    financing and are at your side during the final implementation with our
                    with our construction support service.

                    <><br /> <br /></>

                    As soon as your property is ready to be paved, we carry out the
                    the rest of the work to make it a turnkey home.

                    <><br /> <br /></>
                    We are your competent partner for the entire realisation process
                    with over 30 years of experience.

                    <><br /> <br /></>

                    Contact us without obligation and we will start together with your
                    together with your plans.</>)}
                  </p>
                  <a
                  onClick={closeFunc2}
                    href="#booking-modal"
                    className="button button--slim button--secondary"
                  >
                   {props.lang === "de" ? "  Jetzt kontaktieren!":"Contact now!"}
                  </a>
                </div>
              </div>
            </div>
            {/*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/}
            <div className="offers__card-container offers__card-container--flip">
              <div className="offers__card">
                <div className="offers__card-primary">
                  <div className="offers__image-container">
                    <img className="offers__image" src={laminate} alt="" />
                  </div>
                  <div className="offers__content">
                    <h4 className="offers__content-heading"> {props.lang === "de" ? "Handwerker":"Craftsman"}</h4>
                    <p className="offers__content-subheading">
                     {props.lang === "de" ? "Expertise | Unterstützung | Qualifikation":"Expertise | Support | Qualification"}
                    </p>
                    {/*<div class="offers__content-info">
      <div class="offers__content-info-duration">
      
      <span class="offers__content-info-duration-text">Service | Schlüsselfertig | Erfahrung<strong></strong></span>
      </div>
      
      </div>*/}
                    <div className="offers__content-price-container">
                      <strong className="offers__content-price">
                        <svg className="icon" viewBox="0 0 256 256">
                          <defs></defs>
                          <g
                            style={{
                              stroke: "none",
                              strokeWidth: 0,
                              strokeDasharray: "none",
                              strokeLinecap: "butt",
                              strokeLinejoin: "miter",
                              strokeMiterlimit: 10,
                              fill: "white",
                              fillRule: "nonzero",
                              opacity: 1,
                            }}
                            transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
                          >
                            <path
                              d="M 69.524 43.298 h -0.449 c -0.99 0 -1.93 0.218 -2.774 0.609 c -0.641 -2.99 -3.304 -5.238 -6.481 -5.238 H 59.37 c -1.135 0 -2.204 0.287 -3.139 0.792 c -1.002 -2.392 -3.367 -4.076 -6.118 -4.076 h -0.448 c -0.934 0 -1.822 0.194 -2.628 0.543 v -9.516 c 0 -3.655 -2.974 -6.628 -6.629 -6.628 h -0.449 c -3.655 0 -6.628 2.974 -6.628 6.628 v 24.376 l -3.022 2.294 c -2.403 1.824 -3.927 4.479 -4.29 7.475 c -0.363 2.994 0.482 5.935 2.379 8.279 l 9.423 11.649 v 4.633 c 0 2.799 2.277 5.076 5.076 5.076 h 23.518 c 2.799 0 5.076 -2.277 5.076 -5.076 l 0.001 -4.398 c 3.01 -3.782 4.659 -8.476 4.659 -13.3 V 49.927 C 76.152 46.271 73.179 43.298 69.524 43.298 z M 72.152 67.421 c 0 4.123 -1.484 8.129 -4.18 11.281 c -0.311 0.362 -0.48 0.823 -0.48 1.3 v 5.117 c 0 0.594 -0.482 1.076 -1.076 1.076 H 42.898 c -0.593 0 -1.076 -0.482 -1.076 -1.076 v -5.341 c 0 -0.458 -0.157 -0.901 -0.445 -1.258 l -9.868 -12.199 c -1.21 -1.496 -1.75 -3.372 -1.518 -5.283 s 1.204 -3.604 2.737 -4.77 l 0.604 -0.458 v 5.539 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 v -9.547 c 0 -0.015 0 -0.029 0 -0.044 V 26.413 c 0 -1.449 1.179 -2.628 2.628 -2.628 h 0.449 c 1.449 0 2.628 1.179 2.628 2.628 v 15.601 c 0 0 0 0 0 0.001 s 0 0 0 0.001 l 0.009 12.976 c 0.001 1.104 0.896 1.999 2 1.999 c 0 0 0.001 0 0.001 0 c 1.105 -0.001 2 -0.896 1.999 -2.001 l -0.01 -12.966 c 0 -0.003 0.001 -0.006 0.001 -0.01 c 0 -1.449 1.179 -2.628 2.628 -2.628 h 0.448 c 1.449 0 2.629 1.179 2.629 2.628 v 3.285 c 0 0 0 0.001 0 0.001 c 0 0 0 0.001 0 0.001 l 0.009 9.692 c 0.001 1.104 0.896 1.998 2 1.998 c 0.001 0 0.001 0 0.002 0 c 1.104 -0.001 1.999 -0.897 1.998 -2.002 l -0.009 -9.69 c 0 -1.449 1.179 -2.628 2.628 -2.628 h 0.449 c 1.449 0 2.628 1.179 2.628 2.628 v 4.107 c -0.006 0.066 -0.02 0.13 -0.02 0.197 l 0.01 5.392 c 0.002 1.104 0.897 1.996 2 1.996 c 0.001 0 0.002 0 0.004 0 c 1.104 -0.002 1.998 -0.899 1.996 -2.004 l -0.009 -4.875 c 0.006 -0.062 0.019 -0.121 0.019 -0.184 c 0 -1.449 1.179 -2.628 2.628 -2.628 h 0.449 c 1.449 0 2.628 1.179 2.628 2.628 V 67.421 z"
                              style={{
                                stroke: "none",
                                strokeWidth: 1,
                                strokeDasharray: "none",
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                fill: "white",
                                fillRule: "nonzero",
                                opacity: 1,
                              }}
                              transform=" matrix(1 0 0 1 0 0) "
                              strokeLinecap="round"
                            />
                            <path
                              d="M 28.5 33.873 c -0.668 0 -1.321 -0.334 -1.7 -0.943 c -1.517 -2.437 -2.319 -5.249 -2.319 -8.131 c 0 -8.495 6.911 -15.406 15.406 -15.406 c 8.495 0 15.406 6.911 15.406 15.406 c 0 1.483 -0.211 2.95 -0.626 4.361 c -0.313 1.061 -1.427 1.668 -2.484 1.354 c -1.06 -0.312 -1.665 -1.424 -1.354 -2.483 c 0.308 -1.044 0.464 -2.131 0.464 -3.231 c 0 -6.29 -5.116 -11.406 -11.406 -11.406 s -11.406 5.117 -11.406 11.406 c 0 2.135 0.593 4.216 1.714 6.017 c 0.584 0.938 0.297 2.171 -0.641 2.755 C 29.226 33.775 28.86 33.873 28.5 33.873 z"
                              style={{
                                stroke: "none",
                                strokeWidth: 1,
                                strokeDasharray: "none",
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                fill: "white",
                                fillRule: "nonzero",
                                opacity: 1,
                              }}
                              transform=" matrix(1 0 0 1 0 0) "
                              strokeLinecap="round"
                            />
                            <path
                              d="M 27.248 45.541 c -0.385 0 -0.774 -0.111 -1.118 -0.343 c -6.791 -4.588 -10.846 -12.214 -10.846 -20.4 c 0 -13.566 11.037 -24.603 24.603 -24.603 S 64.49 11.232 64.49 24.798 c 0 3.103 -0.571 6.13 -1.697 8.996 c -0.404 1.028 -1.563 1.537 -2.593 1.13 c -1.028 -0.404 -1.534 -1.564 -1.13 -2.593 c 0.942 -2.398 1.42 -4.933 1.42 -7.533 c 0 -11.36 -9.242 -20.603 -20.603 -20.603 c -11.36 0 -20.603 9.243 -20.603 20.603 c 0 6.855 3.396 13.242 9.085 17.085 c 0.916 0.618 1.156 1.862 0.538 2.777 C 28.521 45.232 27.89 45.541 27.248 45.541 z"
                              style={{
                                stroke: "none",
                                strokeWidth: 1,
                                strokeDasharray: "none",
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                fill: "white",
                                fillRule: "nonzero",
                                opacity: 1,
                              }}
                              transform=" matrix(1 0 0 1 0 0) "
                              strokeLinecap="round"
                            />
                          </g>
                        </svg>
                      </strong>
                    </div>
                  </div>
                </div>
                <div className="offers__card-hover">
                  <p className="offers__content-subheading-hover">
                   {props.lang === "de" ? (<>Ganz egal für welchen Ausgangszustand Sie einen Fachmann
                    oder eine kompetente Unterstützung benötigen. Wir stellen
                    Ihnen innerhalb von kürzester Zeit einen qualifizierten
                    Handwerker für die Behebung Ihrer anfallenden Lasten zur
                    Verfügung.
                    <br/>
                    <br/>
                    Dabei greifen wir auf ein Netzwerk von:
                    <br/>
                    Malern, Bodenlegern, Elektrikern, Fachmänner für Innen- und
                    Außenputz, Fliesenlegern, Installateur, Tischlern, Fassadenreinigern,
                    Dachdeckern, Maurer und Spenglern zurück und arbeiten
                    dahingehend ausschließlich mit selbstständigen Partnern, die
                    innerhalb von minimaler Wartezeit für Sie verfügbar sind.</>): (
                    <>
                      No matter for which initial condition you need a specialist
                    or competent support you need. We provide
                    a qualified craftsman within the shortest possible time
                    craftsman for the repair of your loads within a very short time.
                    available.
                    <br/>
                    <br/>
                    In doing so, we draw on a network of:
                    <br/>
                    
                    painters, floor layers, electricians, interior and exterior plasterers
                    plasterers, tilers, plumbers, carpenters, facade cleaners,
                    roofers, bricklayers and plumbers and work exclusively
                    and work exclusively with independent partners, who can
                    who are available for you within a minimum of waiting time.
                      
                      </>
                    )}
                  </p>
                  <a
                  onClick={closeFunc2}
                    href="#booking-modal"
                    className="button button--slim button--secondary"
                  >
                      {props.lang === "de" ? "  Jetzt kontaktieren!":"Contact now!"}
                  </a>
                </div>
              </div>
            </div>
            {/*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/}
            {/*+++++++++++++++++++++++++++Interior++++++++++++++++++++++++*/}
            <div className="offers__card-container offers__card-container--flip">
              <div className="offers__card">
                <div className="offers__card-primary">
                  <div className="offers__image-container">
                    <img className="offers__image" src={betreuer} alt="" />
                  </div>
                  <div className="offers__content">
                    <h4 className="offers__content-heading"> {props.lang === "de" ? "Traumbetreuer":"Dream coach"}</h4>
                    <p className="offers__content-subheading">
                      {props.lang === "de" ? "Qualität | Planung | Umsetzung":"Quality | Planning | Implementation"}
                    </p>
                    {/*<div class="offers__content-info">
      <div class="offers__content-info-duration">
      
      <span class="offers__content-info-duration-text">Service | Schlüsselfertig | Erfahrung<strong></strong></span>
      </div>
      
      </div>*/}
                    <div className="offers__content-price-container">
                      <strong className="offers__content-price">
                        <svg className="icon" viewBox="0 0 256 256">
                          <defs></defs>
                          <g
                            style={{
                              stroke: "none",
                              strokeWidth: 0,
                              strokeDasharray: "none",
                              strokeLinecap: "butt",
                              strokeLinejoin: "miter",
                              strokeMiterlimit: 10,
                              fill: "white",
                              fillRule: "nonzero",
                              opacity: 1,
                            }}
                            transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
                          >
                            <path
                              d="M 69.524 43.298 h -0.449 c -0.99 0 -1.93 0.218 -2.774 0.609 c -0.641 -2.99 -3.304 -5.238 -6.481 -5.238 H 59.37 c -1.135 0 -2.204 0.287 -3.139 0.792 c -1.002 -2.392 -3.367 -4.076 -6.118 -4.076 h -0.448 c -0.934 0 -1.822 0.194 -2.628 0.543 v -9.516 c 0 -3.655 -2.974 -6.628 -6.629 -6.628 h -0.449 c -3.655 0 -6.628 2.974 -6.628 6.628 v 24.376 l -3.022 2.294 c -2.403 1.824 -3.927 4.479 -4.29 7.475 c -0.363 2.994 0.482 5.935 2.379 8.279 l 9.423 11.649 v 4.633 c 0 2.799 2.277 5.076 5.076 5.076 h 23.518 c 2.799 0 5.076 -2.277 5.076 -5.076 l 0.001 -4.398 c 3.01 -3.782 4.659 -8.476 4.659 -13.3 V 49.927 C 76.152 46.271 73.179 43.298 69.524 43.298 z M 72.152 67.421 c 0 4.123 -1.484 8.129 -4.18 11.281 c -0.311 0.362 -0.48 0.823 -0.48 1.3 v 5.117 c 0 0.594 -0.482 1.076 -1.076 1.076 H 42.898 c -0.593 0 -1.076 -0.482 -1.076 -1.076 v -5.341 c 0 -0.458 -0.157 -0.901 -0.445 -1.258 l -9.868 -12.199 c -1.21 -1.496 -1.75 -3.372 -1.518 -5.283 s 1.204 -3.604 2.737 -4.77 l 0.604 -0.458 v 5.539 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 v -9.547 c 0 -0.015 0 -0.029 0 -0.044 V 26.413 c 0 -1.449 1.179 -2.628 2.628 -2.628 h 0.449 c 1.449 0 2.628 1.179 2.628 2.628 v 15.601 c 0 0 0 0 0 0.001 s 0 0 0 0.001 l 0.009 12.976 c 0.001 1.104 0.896 1.999 2 1.999 c 0 0 0.001 0 0.001 0 c 1.105 -0.001 2 -0.896 1.999 -2.001 l -0.01 -12.966 c 0 -0.003 0.001 -0.006 0.001 -0.01 c 0 -1.449 1.179 -2.628 2.628 -2.628 h 0.448 c 1.449 0 2.629 1.179 2.629 2.628 v 3.285 c 0 0 0 0.001 0 0.001 c 0 0 0 0.001 0 0.001 l 0.009 9.692 c 0.001 1.104 0.896 1.998 2 1.998 c 0.001 0 0.001 0 0.002 0 c 1.104 -0.001 1.999 -0.897 1.998 -2.002 l -0.009 -9.69 c 0 -1.449 1.179 -2.628 2.628 -2.628 h 0.449 c 1.449 0 2.628 1.179 2.628 2.628 v 4.107 c -0.006 0.066 -0.02 0.13 -0.02 0.197 l 0.01 5.392 c 0.002 1.104 0.897 1.996 2 1.996 c 0.001 0 0.002 0 0.004 0 c 1.104 -0.002 1.998 -0.899 1.996 -2.004 l -0.009 -4.875 c 0.006 -0.062 0.019 -0.121 0.019 -0.184 c 0 -1.449 1.179 -2.628 2.628 -2.628 h 0.449 c 1.449 0 2.628 1.179 2.628 2.628 V 67.421 z"
                              style={{
                                stroke: "none",
                                strokeWidth: 1,
                                strokeDasharray: "none",
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                fill: "white",
                                fillRule: "nonzero",
                                opacity: 1,
                              }}
                              transform=" matrix(1 0 0 1 0 0) "
                              strokeLinecap="round"
                            />
                            <path
                              d="M 28.5 33.873 c -0.668 0 -1.321 -0.334 -1.7 -0.943 c -1.517 -2.437 -2.319 -5.249 -2.319 -8.131 c 0 -8.495 6.911 -15.406 15.406 -15.406 c 8.495 0 15.406 6.911 15.406 15.406 c 0 1.483 -0.211 2.95 -0.626 4.361 c -0.313 1.061 -1.427 1.668 -2.484 1.354 c -1.06 -0.312 -1.665 -1.424 -1.354 -2.483 c 0.308 -1.044 0.464 -2.131 0.464 -3.231 c 0 -6.29 -5.116 -11.406 -11.406 -11.406 s -11.406 5.117 -11.406 11.406 c 0 2.135 0.593 4.216 1.714 6.017 c 0.584 0.938 0.297 2.171 -0.641 2.755 C 29.226 33.775 28.86 33.873 28.5 33.873 z"
                              style={{
                                stroke: "none",
                                strokeWidth: 1,
                                strokeDasharray: "none",
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                fill: "white",
                                fillRule: "nonzero",
                                opacity: 1,
                              }}
                              transform=" matrix(1 0 0 1 0 0) "
                              strokeLinecap="round"
                            />
                            <path
                              d="M 27.248 45.541 c -0.385 0 -0.774 -0.111 -1.118 -0.343 c -6.791 -4.588 -10.846 -12.214 -10.846 -20.4 c 0 -13.566 11.037 -24.603 24.603 -24.603 S 64.49 11.232 64.49 24.798 c 0 3.103 -0.571 6.13 -1.697 8.996 c -0.404 1.028 -1.563 1.537 -2.593 1.13 c -1.028 -0.404 -1.534 -1.564 -1.13 -2.593 c 0.942 -2.398 1.42 -4.933 1.42 -7.533 c 0 -11.36 -9.242 -20.603 -20.603 -20.603 c -11.36 0 -20.603 9.243 -20.603 20.603 c 0 6.855 3.396 13.242 9.085 17.085 c 0.916 0.618 1.156 1.862 0.538 2.777 C 28.521 45.232 27.89 45.541 27.248 45.541 z"
                              style={{
                                stroke: "none",
                                strokeWidth: 1,
                                strokeDasharray: "none",
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                fill: "white",
                                fillRule: "nonzero",
                                opacity: 1,
                              }}
                              transform=" matrix(1 0 0 1 0 0) "
                              strokeLinecap="round"
                            />
                          </g>
                        </svg>
                      </strong>
                    </div>
                  </div>
                </div>
                <div className="offers__card-hover">
                  <p className="offers__content-subheading-hover">
               {props.lang === "de" ? (<>
               
                Wir sind IHR Traumbetreuer, wenn es um die Planung und
                    Umsetzung Ihrer Wünsche geht.
          
<br/>
<br/>

                    Hierbei legen wir Wert auf die qualitative Umsetzung aus
                    einer Hand und begleiten Sie vom ersten Schritt, gemeinsam
                    mit unseren regionalen Partnern und Firmen bis hin zum
                    erfolgreichen Abschluss.
               </>):(<>
                We are YOUR dream advisor when it comes to planning and
                    realisation of your wishes.
          
                    <br/>
<br/>

                    We attach great importance to the qualitative realisation from one
                    and accompany you from the first step, together with our regional
                    with our regional partners and companies to the
                    successful completion.
                </>)
               }
                  </p>
                  <a
                  onClick={closeFunc2}
                    href="#booking-modal"
                    className="button button--slim button--secondary"
                  >
                    {props.lang === "de" ? "  Jetzt kontaktieren!":"Contact now!"}
                  </a>
                </div>
              </div>
            </div>
            {/*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/}
            {/*+++++++++++++++++++++++++++Interior2++++++++++++++++++++++++*/}
           
            {/*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/}
            {/*+++++++++++++++++++++++++++Interior3++++++++++++++++++++++++*/}
            
            {/*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/}
            {/*+++++++++++++++++++++++++++Interior4++++++++++++++++++++++++*/}
           
            {/*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/}
          </div>
        </div>
      </section>
      {!isFlipped &&  <section className="booking-modal" id="booking-modal">
        <div className="booking-modal__content">
          <a onClick={closeFunc} className="booking-modal__close" href="/bau&interior">
            x
          </a>
          <h3 className="booking-modal__heading">{props.lang === "de" ? "Jetzt Anfrage stellen!":"Make an enquiry now!"}</h3>
          <p className="booking-modal__paragraph">
          {props.lang === "de" ? "Für Anfragen jeglicher Art, sind bemüht so rasch wie möglich Ihnen zu Antworten.":"For enquiries of any kind, we will try to answer you as soon as possible. to answer you."}
          </p>
          <form ref={form} className="form" onSubmit={sendEmail} >
            <div className="form__horizontal">
              <div className="form__group">
                <input
                  type="text"
                  className="form__input"
                  id="booking-modal-name"
                  name="from_name"
                  placeholder="Name"
                />
                <label className="form__label" htmlFor="booking-modal-name">
                  {props.lang === "de" ? "Name":"Name"}
                </label>
              </div>
              <div className="form__group">
                <input
                  type="text"
                  className="form__input"
                  name="from_email"
                  id="booking-modal-email"
                  placeholder="E-Mail"
                /> 

                  <select name="category" className="form__input2">

                  <option  className="optionS" value="">{props.lang === "de" ? "Bitte wählen Sie eine Kategorie":"Please select a category"} </option>
    <option className="optionS" value="Bau">{props.lang === "de" ? "Handwerker":"Craftsman"}</option>
    <option className="optionS" value="Interior">Interior</option>
    <option className="optionS" value="Hütten">{props.lang === "de" ? "Chalets & Hütten":"Chalets & Cottages"}</option>
    <option className="optionS" value="Chalets">Facility Management</option>


                  </select>
                <label className="form__label" htmlFor="booking-modal-email">
                  E-Mail
                </label>
              </div>
            </div>
            <div className="form__radio-group">
              <div className="form_message">
                <textarea
                name="message"
                  className="form_message-message"
                  type="text"
                  placeholder="Message"
                ></textarea>
              </div>
            </div>
            <div className="booking-modal__submit-container">
              <input
                type="submit"
                className="button button--form"
                defaultValue="Anfrage abschicken!"
                value={props.lang === "de" ? "Anfrage abschicken":"Send enquiry"}
              />
            </div>
          </form>
        </div>
      </section>}
    </div>
  );
};

export default CardsInt;
